'use client';

import Image from 'next/image';

interface HeadingProps {
  title?: string;
  subtitle?: string;
  showcaseImageUrl?: string;
}

export default function Heading({
  title = 'Photo Restoration',
  subtitle = 'Instantly repairs scratches, enhances resolution, and restores details in old photos',
  showcaseImageUrl = 'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/8ff9f2e9-d270-4b81-e331-ce1f8a815300/public',
}: HeadingProps) {
  return (
    <section className='section-container pb-8 md:pb-16'>
      <div className='flex flex-col items-center gap-x-16 md:flex-row'>
        <div className='w-full md:w-1/2'>
          <h1 className='mb-9 text-center text-3xl font-bold leading-[1.11] text-gray-800 md:text-left md:text-6xl'>
            {title}
          </h1>
          <p className='text-center text-base font-medium md:text-left md:text-2xl'>
            {subtitle}
          </p>
        </div>
        <div className='mt-10 md:mt-0 md:w-1/2'>
          <Image
            src={showcaseImageUrl}
            alt='Photo restoration example'
            width={800}
            height={600}
            className='h-auto w-full rounded-xl object-cover'
            sizes='(max-width: 768px) 0px, 50vw'
            priority
          />
        </div>
      </div>
    </section>
  );
}
